// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bbf64-container{padding:0 10px}.a4d63-container_collapsed{padding:0;display:flex;flex-direction:column;align-items:center}", "",{"version":3,"sources":["webpack://./app/pages/EventsPage/EventsSidebar/style.scss"],"names":[],"mappings":"AAAA,iBACE,cAAA,CAGF,2BACE,SAAA,CACA,YAAA,CACA,qBAAA,CACA,kBAAA","sourcesContent":[".container {\n  padding: 0 10px;\n}\n\n.container_collapsed {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "bbf64-container",
	"container_collapsed": "a4d63-container_collapsed"
};
export default ___CSS_LOADER_EXPORT___;
